import type { Dict } from '../i18n';

const dict: Dict = {
  en: {
    heading_legal: 'Legal',
    back_to_sign_in: '← Back to sign in',
    draft_banner:
      'DRAFT — pending legal review. These documents are working drafts for the company\'s lawyer and are not final. Do not rely on them as legal advice.',
    draft_strong: 'DRAFT — pending legal review.',
    draft_body:
      " These documents are working drafts for the company's lawyer and are not final. Do not rely on them as legal advice.",
    tab_privacy: 'Privacy Policy',
    tab_dpa: 'Data Processing Agreement',
    loading: 'Loading…',
    error_load: 'Could not load document',
    error_load_status: 'Could not load document ({{status}})',
  },
  es: {
    heading_legal: 'Legal',
    back_to_sign_in: '← Volver al inicio de sesión',
    draft_banner:
      'BORRADOR — pendiente de revisión legal. Estos documentos son borradores de trabajo para el abogado de la empresa y no son definitivos. No los tome como asesoramiento jurídico.',
    draft_strong: 'BORRADOR — pendiente de revisión legal.',
    draft_body:
      ' Estos documentos son borradores de trabajo para el abogado de la empresa y no son definitivos. No los tome como asesoramiento jurídico.',
    tab_privacy: 'Política de privacidad',
    tab_dpa: 'Acuerdo de procesamiento de datos',
    loading: 'Cargando…',
    error_load: 'No se pudo cargar el documento',
    error_load_status: 'No se pudo cargar el documento ({{status}})',
  },
  de: {
    heading_legal: 'Rechtliches',
    back_to_sign_in: '← Zurück zur Anmeldung',
    draft_banner:
      'ENTWURF — ausstehende rechtliche Prüfung. Diese Dokumente sind Arbeitsentwürfe für den Rechtsanwalt des Unternehmens und nicht endgültig. Verlassen Sie sich nicht auf sie als Rechtsberatung.',
    draft_strong: 'ENTWURF — ausstehende rechtliche Prüfung.',
    draft_body:
      ' Diese Dokumente sind Arbeitsentwürfe für den Rechtsanwalt des Unternehmens und nicht endgültig. Verlassen Sie sich nicht auf sie als Rechtsberatung.',
    tab_privacy: 'Datenschutzerklärung',
    tab_dpa: 'Auftragsverarbeitungsvertrag',
    loading: 'Lädt…',
    error_load: 'Dokument konnte nicht geladen werden',
    error_load_status: 'Dokument konnte nicht geladen werden ({{status}})',
  },
};

export default dict;
